import React from "react";
import { Link } from "react-router-dom";
import "../styles/navbar.css";
import mylogo from "../images/stock2.png";

const AppNavbar = () => {
  return (
    <div className="navbar_container">
      <div className="nav_logo">
        <Link to="">
          <img src={mylogo} alt="My Logo" style={{ width: "35px" }} />
        </Link>
      </div>
      <div className="nav_links">
        <Link className="nav_link" to="/">
          Home
        </Link>
        <Link className="nav_link" to="/markets">
          Markets
        </Link>
        <Link className="nav_link" to="/contact">
          Contact Me
        </Link>
      </div>
    </div>
  );
};

export default AppNavbar;
